export class RepresentanteTableOptions {
    candEdit: boolean;
    canDelete: boolean;
    canImportOneErp_v1: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.candEdit ||
                this.canDelete ||
                this.canImportOneErp_v1;
    }
}
